// @flow
import React from 'react'

// components
import { Popover } from '../../../Components/'

// types
import type { OneQuoteDocuments } from '../../Types/DocumentTypes'
import type { ValueObject } from '../../Types/Values'

export type QuoteHelpComponentProps = {
  id: string,
  help: {
    content: string,
    documents: Array<string>,
    documentNames: { [name: string]: string }
  },
  documents: OneQuoteDocuments,
  onClose?: () => void,
  pushOpen?: boolean,
  target?: string,
  templateVariables: ValueObject,
}

const QuoteHelpComponent = (props: QuoteHelpComponentProps) => {
  let content = ''
  if (props.help) {
    content = props.help.content || ''
    if (props.help.documents && props.help.documents.length && props.help.documentNames) {
      content = content.replace('{documents}', props.help.documents.reduce((acc, documentKey) => {
        if (props.documents[documentKey] && props.help.documentNames[documentKey]) {
          acc += `<strong><a href="${props.documents[documentKey]}" target="_blank">`
            + `<span class="pfp pfp-download pr-2">&nbsp;</span>`
            + `${props.help.documentNames[documentKey]}</a></strong>`
        }
        return acc
      }, ''))
    }
    content = content.replace('{documents}', '')
  }
  return (
    <Popover
      content={content}
      id={props.id}
      onClose={props.onClose}
      pushOpen={props.pushOpen}
      target={props.target}
      templateVariables={props.templateVariables}
    />
  )
}

export default QuoteHelpComponent
